import React, { useState } from 'react';
import { useInput } from '../../lib';
import { MuiTelInput } from 'mui-tel-input'
import { Alert, Box, Button, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { doc, updateDoc } from "firebase/firestore";
import { db } from '../../lib/firebase';
import { useTranslation } from 'react-i18next';

export default function UserInfoForm({ user }) {
  const [userName, handleUserNameChange] = useInput("")
  const [phone, setPhone] = useState('+569')
  const [age, setAge] = useState(dayjs('YYYY-MM-DD'));
  const [userInfoError, setUserInfoError] = useState(null)
  const { t } = useTranslation();

  const handleCreateUserInfo = async () => {
    if (phone.length < 5 || phone == null || userName == null || userName == "" || age == null || age == "Invalid Date") {
      setUserInfoError(t("userInfo.inputError"))
      return
    }

    const userRef = doc(db, "users", user.uid);
    try {
      await updateDoc(userRef, {
        phone: phone,
        userName: userName,
        age: age.format('YYYY-MM-DD')
      });
      setUserInfoError(null)
    } catch (err) {
      console.log(err)
      setUserInfoError(t("userInfo.error"))
    }
  }

  const handlePhoneNumberChange = (newPhone) => {
    setPhone(newPhone)
  }

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {t('userInfo.title')}
      </Typography>
      <Box component="form" sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
        <TextField
          id="user-name"
          label="Name"
          value={userName}
          onChange={handleUserNameChange}
          variant="outlined"
          required />
        <Box sx={{ mt: 3 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t('userInfo.age')}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <MobileDatePicker
                value={age}
                onChange={(newAge) => setAge(newAge)}
                required
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t('userInfo.phone')}
          </Typography>
          {/* https://viclafouch.github.io/mui-tel-input/docs/getting-started/ */}
          <MuiTelInput value={phone} onChange={handlePhoneNumberChange} required />
        </Box>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => handleCreateUserInfo()}>{t('userInfo.save')}</Button>
        {userInfoError != null &&
          <Alert severity="error" sx={{ mt: 2 }}>{userInfoError}</Alert>
        }
      </Box>
    </Box>

  )
}
